import Typography from '@components/Typography';
import Button from '@components/Button/next';
import { FlexibleDiv } from '@components/formStyles';
import { useDevice } from '@contexts/device';

import { ButtonsWrapper, ModalWrapper, Wrapper } from './style';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
};

const CurrentCartTourModal = ({ onClose, onConfirm }: Props) => {
  const { isDesktop } = useDevice();
  return (
    <ModalWrapper>
      <Wrapper>
        <FlexibleDiv bottom={20}>
          <Typography color='D400' variant='caption1' weight='Regular' as='p'>
            Sepetinizde bir tur ürünü bulunmakta. Devam etmeniz halinde
            sepetiniz silinecektir. Devam etmek ister misiniz?
          </Typography>
        </FlexibleDiv>

        <ButtonsWrapper>
          <Button
            hasHover={false}
            block
            variant='Primary'
            outline
            onClick={onClose}
          >
            <Typography
              color='R600'
              variant={isDesktop ? 'caption1' : 'caption2'}
              weight={isDesktop ? 'SemiBold' : 'Bold'}
            >
              Vazgeç
            </Typography>
          </Button>

          <Button block variant='Primary' onClick={onConfirm}>
            <Typography
              color='white'
              variant={isDesktop ? 'caption1' : 'caption2'}
              weight={isDesktop ? 'SemiBold' : 'Bold'}
            >
              Devam Et
            </Typography>
          </Button>
        </ButtonsWrapper>
      </Wrapper>
    </ModalWrapper>
  );
};

export default CurrentCartTourModal;
